import { contentTypeEntries, entryQuickTags } from '@/mocks/entries';
import { featuredStories } from '@/mocks/featured';

export default function HeroUpdate() {
  const main = featuredStories[0];
  const sides = featuredStories.slice(1);

  return (
    <section id="top" className="bg-background-100 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6 md:py-8">
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 rounded-lg border border-background-200 bg-background-50 px-4 py-3 animate-fade-up">
          <span className="flex items-center gap-2 text-sm font-label text-foreground-900 whitespace-nowrap">
            <i className="ri-flashlight-fill text-primary-500"></i>
            今日更新
            <strong className="font-bold text-primary-600">37</strong>
            条
          </span>
          <span className="hidden sm:block w-px h-4 bg-background-300"></span>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-600">
            {entryQuickTags.map((tag) => (
              <span key={tag} className="flex items-center gap-1">
                <span className="w-1 h-1 rounded-full bg-accent-500"></span>
                {tag}
              </span>
            ))}
          </div>
          <span className="ml-auto hidden lg:flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-refresh-line"></i>
            最近更新 13:42
          </span>
        </div>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <a
            href="#kuaixun"
            className="group lg:col-span-7 relative block overflow-hidden rounded-lg border border-background-200 bg-foreground-950 cursor-pointer"
          >
            <div className="relative w-full h-[280px] md:h-[430px]">
              <img
                src={main.cover}
                alt={`${main.category} · ${main.title}`}
                title={`${main.title} 黑料投稿娱乐瓜`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/45 to-foreground-950/5"></div>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-2 mb-3">
                <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-label whitespace-nowrap">
                  {main.badge}
                </span>
                <span className="px-2.5 py-1 rounded-md border border-background-50/25 text-background-100 text-xs whitespace-nowrap">
                  {main.category}
                </span>
              </div>
              <h2 className="font-heading font-bold text-xl md:text-3xl text-background-50 leading-snug">{main.title}</h2>
              <p className="mt-2 text-sm text-background-200/90 max-w-2xl hidden sm:block leading-relaxed">{main.summary}</p>
              <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-200/80">
                <span><i className="ri-fire-line text-primary-400"></i> {main.heat}</span>
                <span><i className="ri-chat-3-line"></i> {main.comments} 条讨论</span>
                <span className="text-primary-300"><i className="ri-arrow-right-line"></i> 查看处理时间线</span>
              </div>
            </div>
          </a>

          <div className="lg:col-span-5 flex flex-col gap-6">
            <div>
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
                  <span className="w-1 h-4 rounded-full bg-accent-500"></span>
                  内容入口
                </h3>
                <span className="text-xs text-foreground-500">点击进入对应专区</span>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {contentTypeEntries.map((entry) => (
                  <a
                    key={entry.id}
                    href={entry.href}
                    className="group rounded-lg border border-background-200 bg-background-50 p-4 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
                  >
                    <div className="flex items-center justify-between">
                      <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center text-lg">
                        <i className={entry.icon}></i>
                      </span>
                      <span className="px-1.5 py-0.5 rounded text-[11px] bg-accent-100 text-accent-700 font-label">
                        {entry.badge}
                      </span>
                    </div>
                    <div className="mt-3 font-heading font-bold text-sm text-foreground-950">{entry.name}</div>
                    <div className="mt-1 text-xs text-foreground-500 leading-relaxed">{entry.desc}</div>
                    <div className="mt-2 text-xs text-primary-600 font-label flex items-center gap-1">
                      {entry.count} 条
                      <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {sides.map((side) => (
                <a
                  key={side.id}
                  href="#kuaixun"
                  className="group rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
                >
                  <div className="w-full h-[120px] overflow-hidden">
                    <img
                      src={side.cover}
                      alt={side.title}
                      title={`${side.title} 黑料投稿`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-3">
                    <span className="text-[11px] text-accent-700 bg-accent-100 px-1.5 py-0.5 rounded">{side.category}</span>
                    <h4 className="mt-2 text-sm font-medium text-foreground-900 leading-snug line-clamp-2">{side.title}</h4>
                    <div className="mt-2 text-[11px] text-foreground-500">
                      {side.heat} · {side.comments} 讨论
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}